import { IMailWizzEntity } from '../common/mailwizz-entity';
import { isNull } from '@/shared/utils/utils';
import { INamedEntity } from '../common/named-entity';

export class List implements IMailWizzEntity, INamedEntity {

    name: string = '';
    mailWizzEntityId: string;

    static parseJson(json: any): List {
        if (isNull(json)) { return null; }

        return Object.assign(new List(), json);
    }
}
